module.exports = __webpack_public_path__ + "img/yx3.3a74deea.jpg";